import * as React from 'react';
import { Box, Typography, Card, Chip, MuiBox } from '@kis-technologies/kis-ui';
import { useSelector } from 'react-redux';
import { selectors as hardwareSelectors, EventData as EventDataProps } from 'services/hardware';
import { OPERATIONAL, NOT_CONNECTED } from 'constants/hardware';
import { useStyles } from '../styled';

export const EventData = () => {
  // Actions and Selectors
  const { status } = useSelector(hardwareSelectors.selectEventData) as EventDataProps;

  const classes = useStyles();

  // **************
  // **  RENDER  **
  // **************

  const renderMessage = () => {
    if (status.code === OPERATIONAL) return 'Your ticketing data is online and no additional action is required.';
    if (status.code === NOT_CONNECTED) return 'Your ticketing data is experiencing some issues.';
    return null;
  };

  const renderAction = () => {
    if (status.code === OPERATIONAL) {
      return <Chip appearance="success" label={'Online'} className={classes.statusChip} />;
    }
    if (status.code === NOT_CONNECTED) {
      return <Chip appearance="error" label={'Offline'} className={classes.statusChip} />;
    }
    return null;
  };

  return (
    <MuiBox className={classes.systemCheckHardwareDevices} margin="0 3 0 0">
      <Card fullHeight hasBorderRadius raised>
        <Card.Title
          gutter={5}
          title={
            <Typography fontSize={24} fontWeight={900}>
              Event Data
            </Typography>
          }
          action={renderAction()}
        />
        <Card.Content gutter={5}>
          <Box flexOverride="1">
            <Typography fontSize={15}>{renderMessage()}</Typography>
          </Box>
        </Card.Content>
      </Card>
    </MuiBox>
  );
};
